import { styled, FormGroup as FormGroup$1 } from '@mui/material';
import { spacing } from '@mui/system';

const FormGroup = styled(FormGroup$1)(spacing);

export { FormGroup };
